import { IProfile } from "@assetmark/profile/dist/profileComponent";
import { none } from "fp-ts/lib/Option";
import { TLeadProfileResponse } from "../models/lead-profile-response";
import { TAnalysisAccountDetailResponse } from '../models/analysis-account-details.model';

export type TOtherIncome = {
	Id: number;
	IncomeSourceTypeId: number;
	MonthlyIncome?: number;
};

export const defaultLeadProfile: TLeadProfileResponse = {
    leadProfileId: none,
    leadStrategyId: [],
    firstName: none,
    lastName: none,
    fullName: none,
    emailAddress: none,
    age: none,
    agentId: none,
    createdDate: none,
    leadStrategy: []
};

export const defaultProfileData: IProfile = {
    Investor: {
        FirstName: '',
        LastName: '',
        EmailAddress: '',
        Age: 0,
    },
    investmentInfo: {
        InvestmentAmount: 0,
    },
    investmentReason: '0',
    page: 0
};

export const defaultGoalsProfile = {
    id: none,
    leadId: none,
	leadStrategyId: [],
    goalTypeId: none,
    createdDate: none,
    agentId: none,
    investmentAmount: none,
    targetGrowthAmount: none,
    targetGoalYear: none,
    monthlyIncome: none,
    monthlyIncomeToRetirePercent: none,
    netRetirementMonthlyIncome: none,
    leadOtherRetirementIncome: none,
    savingsCurrent: none,
    annualSavings: none,
    birthYear: none,
    lifeExpectancy: none,
    inflation: none,
    investmentTypeEnum: none
};

export const defaultGoalsData = {
    targetGrowthAmount: 0,
    targetGoalYear: 0,
    monthlyIncome: 0,
    monthlyIncomeToRetirePercent: 0,
    NetRetirementMonthlyIncome: 0,
      OtherRetirementIncomes: [{
        Id: '',
        IncomeSourceTypeId: 0
        
      }],
    savingsCurrent: 0,
    annualSavings: 0,
    birthYear: 0,
    lifeExpectancy: 0,
    inflation: 0
    // currentRoute: none
};

export const defaultAnalysisAccountDetails: TAnalysisAccountDetailResponse = {
    name: 'Test',
    email: 'Test@test.com',
    goalType: '2',
    investmentAmount: 20000,
    currentAnnualContribution: 480,
    currentAge: 22,
    targetRetirementAge: 65,
    targetAnnualIncome: 30000,
    lifeExpectancy: 90,
    inflationRate: 2,
    targetAmount: 50000,
    riskProfile: 2,
    proposalCreated: "2021-09-13T14:21:23.456Z"
};

export const INVESTMENT_RETURN_RANGE_QUESTION = "During any 12 month period, returns on portfolios   with exposure to \r\nthe stock market can vary dramatically.  Given this variability and\r\nyour initial investment of $amount, please select the typical   \r\nrange of potential gains and losses with which you are most comfortable.*";